module.exports = __webpack_public_path__ + "h5/img/advert.eb099af1.png";